import { FC } from "react";
import { Styled } from "./styled";
import useVideo, { IProps } from "./hook";

const VideoLayout = (props: ReturnType<typeof useVideo>) => {
  return (
    <Styled>
      <audio
        controlsList="nodownload"
        controls
        style={{ maxHeight: "calc(100% - 10px)" }}
        src={props.uri}
      ></audio>
    </Styled>
  );
};

const Video: FC<IProps> = (props: IProps) => (
  <VideoLayout {...useVideo(props)} />
);

export default Video;
